'use client';

import { CookieFreeIcons } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Button } from '@tajdid/tajdid-ui';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

type CookiePreferences = { essential: boolean } | undefined;

export default function CookieConsent() {
  const [cookiePreferences, setCookiePreferences] =
    useLocalStorage<CookiePreferences>('cookie-consent', undefined);
  const [isClientRendered, setIsClientRendered] = useState(false);

  const t = useTranslations();

  useEffect(() => {
    setIsClientRendered(true);
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = {
      essential: true,
    };

    setCookiePreferences(allAccepted);
  };

  const handleRejectAll = () => {
    const essentialOnly = {
      essential: true,
    };

    setCookiePreferences(essentialOnly);
  };

  if (!isClientRendered) {
    return null;
  }

  if (cookiePreferences) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t bg-white p-4">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-2 md:gap-6 md:flex-row md:items-center">
          <div className="flex-1">
            <div className="mb-2 flex items-center gap-2 text-lg font-semibold text-primary-600">
              <div className="rounded-md bg-primary-600 p-2 text-white">
                <HugeiconsIcon icon={CookieFreeIcons} />
              </div>
              <span className="font-bold">{t('cookie-consent.title')}</span>
            </div>
            <p className="mb-2 text-justify text-sm text-gray-600">
              {t('cookie-consent.description')}
            </p>
          </div>
          <div className="flex w-full flex-wrap justify-end gap-2 md:w-auto md:flex-nowrap md:gap-4">
            <Button
              variant="outlined"
              size="medium"
              onClick={handleRejectAll}
              className="text-xs bg-transparent"
            >
              {t('cookie-consent.decline')}
            </Button>
            <Button
              variant="outlined"
              size="medium"
              onClick={handleAcceptAll}
              className="text-xs bg-primary-500 text-white hover:bg-primary-700"
            >
              {t('cookie-consent.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
